import Tab, { TabProps } from '@mui/material/Tab'
import Tabs, { TabsProps } from '@mui/material/Tabs'

const StyledTabs = ({ ...props }: TabsProps) => (
  <Tabs
    {...props}
    sx={{
      '& .MuiTabs-indicator': {
        backgroundColor: '#1890ff',
        display: 'none'
      },
      display: 'inline-flex',
      backgroundColor: '#EBECF2',
      minHeight: 0,
      height: 'auto',
      padding: '2px',
      borderRadius: '4px',
      overflow: 'hidden',
      ...props.sx
    }}
  />
)

const StyledTab = ({ ...props }: TabProps) => (
  <Tab
    {...props}
    sx={{
      margin: 0,
      minHeight: 0,
      fontFamily: 'Sora',
      color: '#696C80',
      '&:hover': { opacity: 1 },
      backgroundColor: '#EBECF2',
      textTransform: 'none',
      '&.MuiTab-root': { maxHeight: '35px', maxWidth: '400px' },
      '&.Mui-focusVisible': { backgroundColor: '#d1eaff' },
      '&.Mui-selected': { color: 'black', backgroundColor: 'white' },
      ...props.sx
    }}
  />
)

export { StyledTab, StyledTabs }
